import React from 'react';
// import { Link } from 'react-router-dom';
import { Header } from 'semantic-ui-react';
import './SiteFooter.css';

const { REACT_APP_ENJOY_SITE_ROOT_URL } = process.env;

export const SiteHeader = () => (
    <Header className="sitefooter" as="h4">
        {/* <a href={`${REACT_APP_SHOW_BASE_URL}/faq`} >FAQ</a>
        <a href={`${REACT_APP_SHOW_BASE_URL}/help`} >Help Center</a>
        <a href={`${REACT_APP_SHOW_BASE_URL}/termsofuse`} >Terms of Use</a>
        <a href={`${REACT_APP_SHOW_BASE_URL}/privacypolicy`} >Privacy Policy</a> */}
        {/* <a href={`${window.location.origin}/faq`} target="_blank" >FAQ</a>
        <a href={`${window.location.origin}/help`} target="_blank" >Help Center</a>
        <a href={`${window.location.origin}/termsofuse`} target="_blank" >Terms of Use</a>
        <a href={`${window.location.origin}/privacypolicy`} target="_blank" >Privacy Policy</a> */}
        <a href={`${REACT_APP_ENJOY_SITE_ROOT_URL}/helpcenter`} target="_blank" rel="noopener noreferrer">Help Center</a>
        <a href={`${REACT_APP_ENJOY_SITE_ROOT_URL}/featurelist`} target="_blank" rel="noopener noreferrer">Features</a>
        <a href={`${REACT_APP_ENJOY_SITE_ROOT_URL}/termsofuse`} target="_blank" rel="noopener noreferrer">Terms of Use</a>
        <a href={`${REACT_APP_ENJOY_SITE_ROOT_URL}/privacypolicy`} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        {/* <Link to="/faq" target="_blank" >FAQ</Link>
        <Link to="/featurelist" target="_blank" >Features</Link>
        <Link to="/termsofuse" target="_blank" >Terms of Use</Link>
        <Link to="/privacypolicy" target="_blank" >Privacy Policy</Link> */}
    </Header>
);

export default SiteHeader;
